export const API_HOST = import.meta.env.VITE_API_HOST
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
export const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
export const VITE_GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
export const EmmaUUID = '61b22789f14b0a93896f54ee'
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_MAPS_API_KEY
/** Earliest date for Einstein Games–family reports (EG, Damages, Reviews, Attendance, Safety, Contract Efficiency) */
export const EINSTEIN_GAMES_MIN_DATE = '2026-02-01'

export const COLORS = {
  orange: '#EF8B22',
  emerald: '#10B981',
  green: '#22C55E',
  amber: '#F59E0B',
  red: '#EF4444',
  gray: '#6B7280',
  blue: '#3B82F6',
}

/** Shared UI surface / border colors used across tables, cards, and containers */
export const UI_COLORS = {
  /** Light gray border — card borders, section dividers */
  border: '#E5E7EB',
  /** Very light gray — subtle row stripes, hover backgrounds */
  bgSubtle: '#F9FAFB',
  /** Light gray — alternate row backgrounds, section fills */
  bgMuted: '#F3F4F6',
  /** Near-white — detail panel backgrounds */
  bgSurface: '#FAFBFC',
}

export const TABLE_HEAD_CELL_STYLE = {
  fontSize: '11px',
  fontWeight: 600,
  color: COLORS.gray,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.5px',
  backgroundColor: UI_COLORS.bgSubtle,
  borderBottom: 'none',
}

export const CIRCLE_CELL_STYLE = {
  width: '9px',
  height: '9px',
  borderRadius: '50%',
}
